var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{attrs:{"type":_vm.type,"placeholder":"选择日期","format":_vm.data_format,"disabled":_vm.disabled,"transfer":""},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }